import Grid from '@mui/material/Grid';
import {
  Field2 as Field,
  DaySelector,
} from 'vibeguide';

const hourOptions = [];
for (let i = 0; i <= 24; i++) {
  const hour = i < 10 ? `0${i}:00` : `${i}:00`;
  hourOptions.push({
    label: hour,
    value: hour,
  });
}

function SegmentDateTime({
  startDate = '',
  endDate = '',
  daysOfWeek = [],
  disableInput = false,
  onUpdate = () => {},
}) {
  const onChangeStartDate = (startDate) => {
    onUpdate({
      startDate,
    });
  };

  const onChangeEndDate = (endDate) => {
    onUpdate({
      endDate,
    });
  };

  const onChangeDays = (days) => {
    onUpdate({
      daysOfWeek: days,
    });
  };

  return (
    <Grid className="SegmentDateTime" spacing={2} container>
      <Grid size={6}>
        <Field
          type="datepicker"
          label="Start Date"
          placeholder="YYYY-MM-DD"
          value={startDate}
          dateProps={{
            format: 'YYYY-MM-DD',
          }}
          tabIndex={36}
          disabled={disableInput}
          onChange={onChangeStartDate}
          required
        />
      </Grid>

      <Grid size={6}>
        <Field
          type="datepicker"
          label="End Date"
          placeholder="YYYY-MM-DD"
          value={endDate}
          dateProps={{
            format: 'YYYY-MM-DD',
          }}
          tabIndex={37}
          disabled={disableInput}
          onChange={onChangeEndDate}
          required
        />
      </Grid>

      <Grid size={12}>
        <Field
          type="custom"
          label="Days"
          tabIndex={38}
          required
        >
          <DaySelector
            style={{
              width: 250,
            }}
            dayFormat="dd"
            selectedDays={daysOfWeek}
            toggleAll
            disabled={disableInput}
            onChange={onChangeDays}
          />
        </Field>
      </Grid>
    </Grid>
  );
}

export default SegmentDateTime;
